export const ESuggestionTypes = Object.freeze({
    /**
     * подсказки по ФИО
     * @deprecated since new version, use `FIO`
     */
    NAME: 'fio',
    /**
     * подсказки по ФИО
     */
    FIO: 'fio',
    /**
     * подсказки по организациям
     */
    PARTY: 'party',
    /**
     * кем выдан паспорт
     */
    FMS_UNIT: 'fms_unit',
    /**
     * подсказки по адресам
     */
    ADDRESS: 'address',
    /**
     * подсказки по email
     */
    EMAIL: 'email',
    /**
     * виды деятельности (ОКВЭД 2)
     */
    OKVED2: 'okved2',
    /**
     * муниципальные образования (ОКТМО
     */
    OKTMO: 'oktmo',
    /**
     * подсказки по банкам
     */
    BANK: 'bank',
});
